import * as I18n from 'i18n-js';
import { fixPrecision } from './bump_helpers';

export function recommendationText(
  recommendationAmount: number,
) {
  return I18n.t('discovery.bumpModalV2.buyBoxRecommendation', {
    tagOpen: '<span class="weight-bold">',
    tagClose: '</span>',
    bumpPercent: fixPrecision(recommendationAmount),
  });
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/bump/button_display_recommendations.tsx